import { createContext, Dispatch, SetStateAction } from 'react';
import { ControllerToastSeverity } from '@bymason-private/legacy-pattern-components';

export interface ToastContext {
  setToastMessage: Dispatch<SetStateAction<string>>;
  setToastSeverity: Dispatch<SetStateAction<ControllerToastSeverity | undefined>>;
  closeToast: () => void;
}

const initialContext = {
  setToastMessage: (): void => {
    throw new Error('Toast Context not set');
  },
  setToastSeverity: (): void => {
    throw new Error('Toast Context not set');
  },
  closeToast: () => {
    throw new Error('Toast Context not set');
  },
};

export default createContext<ToastContext>(initialContext);
